import React, { useState } from 'react';

const ConsentBanner = () => {
  const [showBanner, setShowBanner] = useState(() => {
    return localStorage.getItem("cookiesAccepted") !== "true";
  });

  const handleAccept = () => {
    // Guardar el consentimiento en localStorage
    localStorage.setItem("cookiesAccepted", "true");

    // Actualizar el consentimiento en GTM
    window.dataLayer.push({
      'event': 'update_consent',
      'ad_storage': 'granted',
      'analytics_storage': 'granted'
    });

    setShowBanner(false);
  };

  const handleClose = () => {
    setShowBanner(false);
  };

  return showBanner ? (
    <div style={{
      position: 'fixed',
      bottom: '1rem',
      left: '50%',
      transform: 'translateX(-50%)',
      width: '90%',
      maxWidth: '500px',
      background: 'linear-gradient(135deg, #FFF, #FFF)',
      color: '#fff',
      padding: '1.5rem',
      textAlign: 'center',
      zIndex: 1000,
      boxShadow: '0 4px 10px rgba(0, 0, 0, 0.3)',
      borderRadius: '10px',
      fontSize: '1rem',
    }}>
      <p style={{ margin: '0 0 1rem', lineHeight: '1.5' }}>
        Usamos cookies para mejorar tu experiencia. ¿Aceptas?
      </p>
      <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem' }}>
        <button 
          onClick={handleAccept} 
          style={{
            backgroundColor: '#fff',
            color: '#001346',
            border: '2px solid #001346',
            padding: '0.75rem 1.5rem',
            fontSize: '1rem',
            borderRadius: '25px',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
          }}
          onMouseOver={(e) => {
            e.target.style.backgroundColor = '#001346';
            e.target.style.color = '#fff';
          }}
          onMouseOut={(e) => {
            e.target.style.backgroundColor = '#fff';
            e.target.style.color = '#001346';
          }}
        >
          Aceptar
        </button>
        <button 
          onClick={handleClose} 
          style={{
            backgroundColor: '#fff',
            color: '#FF0000',
            border: '2px solid #FF0000',
            padding: '0.75rem 1.5rem',
            fontSize: '1rem',
            borderRadius: '25px',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
          }}
          onMouseOver={(e) => {
            e.target.style.backgroundColor = '#FF0000';
            e.target.style.color = '#fff';
          }}
          onMouseOut={(e) => {
            e.target.style.backgroundColor = '#fff';
            e.target.style.color = '#FF0000';
          }}
        >
          Cerrar
        </button>
      </div>
    </div>
  ) : null;
};

export default ConsentBanner;
